import {useDispatch, useSelector} from "react-redux";
import {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../components/Button/Button";
import SortableGroups from "./SortableGroups";
import NewModifierModal from "./NewModifierModal";
import EditModifierModal from "./EditModifierModal";
import { onModifierArchive, onModifierCategoriesNew, onModifierCategoryNameEdit, onModifiersEdit, onModifiersModalEdit, onModifiersModalNew, onModifierUnarchive} from "../../../store/Modifiers/actions";
import { onCategoriesModalEdit } from "../../../store/Categories/actions";
import EditCategoryModal from "../EditCategoryModal";
import { MenuCategoriesItem } from "../MenuCategoriesItem";


export const MenuModifierCategories = ({ onOpenEditModifierCategory, filteredModifierCategory, isModifier }) => {
    const [state, setState] = useState([]);
   
    useEffect(() => setState(filteredModifierCategory), [filteredModifierCategory]);
 
    if (!state || (state && !state.length)) return null;

    return (
        <div>
            {state.map((modifier_category) => (
                <MenuCategoriesItem
                    key={modifier_category.id}
                    category={modifier_category}
                    isModifier={isModifier}
                    onOpenEditCategory={onOpenEditModifierCategory}
                />
            ))}
        </div>
    );
};

const Modifiers = ({ modalEditCategory, filteredModifierCategory, isModifier }) => {
    const dispatch = useDispatch();
    const [modifierCategory, setModifierCategory] = useState({});

    const onOpenEditModifierCategory = (modifierCategory) => {
        setModifierCategory(modifierCategory);
        dispatch(onCategoriesModalEdit(true));
    };
    const onCloseEditModifierCategory = () => {
        setModifierCategory({});
        dispatch(onCategoriesModalEdit(false));
    };
    const onChangeModifierCategoryName = (e) => { setModifierCategory({ ...modifierCategory, name: e.target.value })};
    const onSaveEditCategory = () => {
        dispatch(onModifierCategoryNameEdit(modifierCategory));
        onCloseEditModifierCategory()
    };
    const onArchived = () => {
        dispatch(onModifierArchive(modifierCategory.id));
        onCloseEditModifierCategory()
    };
    const onUnArchived = () => {
        dispatch(onModifierUnarchive(modifierCategory.id));
        onCloseEditModifierCategory()
    };

    return (
        <>
            <MenuModifierCategories
                filteredModifierCategory={filteredModifierCategory}
                onOpenEditModifierCategory={onOpenEditModifierCategory}
                isModifier={isModifier}
            />
            <EditCategoryModal
                category={modifierCategory}
                isModifier={isModifier}
                visible={modalEditCategory}
                onClose={onCloseEditModifierCategory}
                onChangeName={onChangeModifierCategoryName}
                onSave={onSaveEditCategory}
                onArchived={onArchived}
                onUnArchived={onUnArchived}
            />
        </>
    );
};

export default Modifiers;


// export const Modifiers1 = () => {
//     const { t } = useTranslation()
//     const dispatch = useDispatch();
//     const [editCategory, setEditCategory] = useState({})

//     const { modifiers, loading, modalNewModifier, modalEditModifier } = useSelector(({ modifiers }) => ({
//         modalNewModifier: modifiers.modalNewModifier,
//         modalEditModifier: modifiers.modalEditModifier,
//         loading: modifiers.loading,
//         modifiers: modifiers.modifiers,
//     }));

//     const onOpenNew = () => dispatch(onModifiersModalNew(true));
//     const onCloseNew = () => dispatch(onModifiersModalNew(false));

//     const onOpenEditCategory = (editCategory) => {
//         setEditCategory(editCategory)
//         dispatch(onModifiersModalEdit(true))
//     };
//     const onCloseEditCategory = () => {
//         setEditCategory({})
//         dispatch(onModifiersModalEdit(false))
//     };

//     return (
//         <>
//             <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 mb-6 flex justify-between">
//                 <Button onClick={onOpenNew}>
//                     {t('New modifier group')}
//                 </Button>
//             </div>

//             <SortableGroups items={modifiers} onOpenEditCategory={onOpenEditCategory} />

//             {modalNewModifier ?(
//                 <NewModifierModal
//                     loading={loading}
//                     visible={modalNewModifier}
//                     onClose={onCloseNew}
//                 />
//             ): null}

//             <EditModifierModal
//                 editCategory={editCategory}
//                 loading={loading}
//                 visible={modalEditModifier}
//                 onClose={onCloseEditCategory} />
//         </>
//     );
// }
